import React from 'react';
import { Box, BoxProps } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { LargeCopy } from '../../Output.styles';
import { CategoryScore } from '../CategoryScore/CategoryScore';
import { CategoryInfoDTO, ComparisonItemsDTO } from '../../../api/useSurveyResultsQuery';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { CATEGORIES_COMPARISON_ITEMS } from './ComparingCategory.meta';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';
import { Lozenge } from '../../../../CommonComponents/OPL/Lozenge/Lozenge';

interface ComparingCategoryProps extends BoxProps {
  label: string;
  description: string;
  primaryRespondentScore: number;
  secondaryRespondentName: string;
  secondaryRespondentScore: number;
  compatibilityScore: number;
  comparisonItems: ComparisonItemsDTO;
  categoryInfo: CategoryInfoDTO;
  isPrint?: boolean;
}

export const ComparingCategory = ({
  label,
  description,
  categoryInfo,
  comparisonItems,
  primaryRespondentScore,
  secondaryRespondentName,
  secondaryRespondentScore,
  compatibilityScore,
  isPrint,
  ...rest
}: ComparingCategoryProps) => {
  const isMobile = useIsMobile();

  return (
    <Box {...rest}>
      <Lozenge mb="16">{label}</Lozenge>

      <Text fontSize="h3" fontWeight={600} color="neutral.800" mb="16">
        {categoryInfo[label].header}
      </Text>

      <CategoryScore
        mt="16"
        primaryRespondentScore={primaryRespondentScore}
        secondaryRespondentScore={secondaryRespondentScore}
        secondaryRespondentName={secondaryRespondentName}
        leftComparison={categoryInfo[label].low}
        rightComparison={categoryInfo[label].high}
        compatibilityScore={compatibilityScore}
      />

      <LargeCopy mt="16" mb="32">
        {description}
      </LargeCopy>

      {comparisonItems && (
        <Box
          display="grid"
          as="ul"
          p="0"
          mt="24"
          css={`
            list-style: none;
            grid-template-columns: repeat(${isMobile ? 1 : 2}, 1fr);
            gap: ${({ theme }) => theme.space[16]}px;
          `}
        >
          {Object.keys(CATEGORIES_COMPARISON_ITEMS).map(key => {
            const { title, icon } = CATEGORIES_COMPARISON_ITEMS[key];
            const value = comparisonItems[key];

            return (
              <Box as="li" mb="24" key={key}>
                <Icon className={icon} fontSize="h4" color="neutral.500" mb="16" aria-hidden />

                <Text fontWeight={600}>{title}</Text>

                <Text>{value}</Text>
              </Box>
            );
          })}
        </Box>
      )}

      {!isPrint && <Separator />}
    </Box>
  );
};
